import { render, staticRenderFns } from "./RoamingZoneCreate.vue?vue&type=template&id=67ecbcdf&scoped=true"
import script from "./RoamingZoneCreate.vue?vue&type=script&lang=ts"
export * from "./RoamingZoneCreate.vue?vue&type=script&lang=ts"
import style0 from "./RoamingZoneCreate.vue?vue&type=style&index=0&id=67ecbcdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ecbcdf",
  null
  
)

export default component.exports